import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-synoptic-errors',
    styleUrls: ['./synoptic-errors.component.scss'],
    templateUrl: './synoptic-errors.component.html',
})
export class SynopticErrorsComponent {
    public readonly errors = input.required<string[]>();
    public readonly isErrorsOpen = signal(false);

    public toggleErrors(): void {
        this.isErrorsOpen.update((value: boolean) => !value);
    }
}
